import {connect} from 'react-redux';
import {includes} from 'lodash';
import './ComparablePropertyAccordion.scss';
import ComparablePropertyAccordion from './ComparablePropertyAccordion';
import {isNZLocale} from 'lib/PropertyUtils';
import * as ComparableSalesActions from 'actionCreators/comparableSales';
import * as ComparableListingsActions from 'actionCreators/comparableListings';
import * as ComparableRentalsActions from 'actionCreators/comparableRentals';
import featuredSalesMarker from 'images/featured_sales_marker.png';
import featuredListingsMarker from 'images/featured_listings_marker.png';
import featuredRentalsMarker from 'images/featured_rentals_marker.png';
import {fetchAdvertisement} from 'actionCreators/propertyFetchingActions';
import {escapeHtml, truncateString} from 'lib/StringUtils';

const ducks = {
  sales: {
    actions: ComparableSalesActions,
    store: ({comparableSales}) => comparableSales,
  },
  listings: {
    actions: ComparableListingsActions,
    store: ({comparableListings}) => comparableListings,
  },
  rentals: {
    actions: ComparableRentalsActions,
    store: ({comparableRentals}) => comparableRentals,
  },
};

function getTruncatedAdvertisementDescription(property) {
  const truncateTextLength = 200;
  if (property.advertisementDescription) {
    const escapedAd = escapeHtml(property.advertisementDescription);
    return truncateString(escapedAd, truncateTextLength);
  }
  return null;
}

const mapStateToProps = (state, ownProps) => {
  const isNZ = isNZLocale();
  const comparableTypes = {
    listings: 'Comparable Listings',
    sales: 'Comparable Sales',
    rentals: 'Comparable Rentals',
  };
  const pageContext = comparableTypes[ownProps.comparableType];
  const comparableItems = ducks[ownProps.comparableType].store(state);
  const selected = includes(comparableItems.selected, ownProps.propertyId);
  const featured = includes(comparableItems.featured, ownProps.propertyId);
  const markerImg = ownProps.comparableType === 'sales' ? featuredSalesMarker
    : ownProps.comparableType === 'listings' ? featuredListingsMarker
      : featuredRentalsMarker;
  const property = comparableItems.properties[ownProps.propertyId];
  const advertisementDescription = getTruncatedAdvertisementDescription(property);

  return {
    ...ownProps,
    advertisementDescription,
    isNZ,
    selected,
    featured,
    featureFlags: state.featureFlags,
    markerImg,
    property,
    pageContext,
    propertyDetailsSpacing: isNZ ? 6 : 4,
    settings: state.settings,
    reportType: state.reportType?.value || 'cma'
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const {comparableType, propertyId} = ownProps;
  const duck = ducks[ownProps.comparableType].actions;

  return {
    onImageSelect: (currentImageIndex) => {
      dispatch(duck.updateForSession({
        propertyId: ownProps.propertyId,
        keyPath: 'propertyPhotoUriSelectedIndex',
        value: currentImageIndex,
      }, true));
    },
    onUpload: (files) => {
      dispatch(duck.uploadComparableImage(ownProps.propertyId, files[0]));
    },
    onDelete: (currentImageIndex) => {
      dispatch(duck.deleteUploadedImage(ownProps.propertyId, currentImageIndex));
    },
    onFetchAdvertisementDescription: () => {
      dispatch(fetchAdvertisement({propertyId, comparableType}));
    },
    onSelectChange: (event, data) => {
      if (data.checked) {
        dispatch(duck.addSelectedItem(ownProps.propertyId));
      } else {
        dispatch(duck.removeSelectedItem(ownProps.propertyId));
      }
      event.stopPropagation();
    },
    onAddFeatured: () => dispatch(duck.featureProperty(ownProps.propertyId, true)),
    onRemoveFeatured: () => dispatch(duck.removeFeatureProperty(ownProps.propertyId)),
    onRemoveSelected: () => dispatch(duck.removeSelectedItem(ownProps.propertyId)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

/**
 * Component for comparable sales and comparable listings.
 */
const ComparablePropertyAccordionContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ComparablePropertyAccordion);

export {ComparablePropertyAccordionContainer, ComparablePropertyAccordion};
export default ComparablePropertyAccordionContainer;
